module.exports = __webpack_public_path__ + "static/media/logo_white_circle.12d744ab.png";